function initbenefitsSlider() {
    const sliderWrapper = document.querySelectorAll('.benefits-slider__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#benefits-slider-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');

        if (!container) return;

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            effect: "slide",
            slidesPerView: 1.075,
            spaceBetween: 10,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
            breakpoints: {
                700: { slidesPerView: 2.1 },
                1000: { slidesPerView: 3.1 },
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
initbenefitsSlider();
});